import { FC } from 'react';

import { Box, TextField, Typography, CircularProgress, ListItemButton, ListItemText } from '@mui/material';

import { SelectedUser } from '../types';
import { getUserContact } from '../utils';

import { UserModel } from 'v2/types/UserModel';

interface UserSearchProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  users: UserModel[];
  isLoading: boolean;
  selectedUsers: SelectedUser[];
  onUserSelect: (user: UserModel) => void;
}

export const UserSearch: FC<UserSearchProps> = ({
  searchQuery,
  onSearchChange,
  users,
  isLoading,
  selectedUsers,
  onUserSelect,
}) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Search Users
      </Typography>

      <TextField
        fullWidth
        label="Search users"
        value={searchQuery}
        onChange={(e) => onSearchChange(e.target.value)}
        placeholder="Enter user nickname, tg username or email (minimum 2 characters)"
        sx={{ mb: 2 }}
        InputProps={{
          endAdornment: isLoading && <CircularProgress size={20} />,
        }}
      />

      {users.length > 0 && searchQuery && (
        <Box
          sx={{
            maxHeight: 200,
            overflow: 'auto',
            border: '1px solid #ddd',
            borderRadius: 1,
          }}
        >
          {users.map((user) => (
            <ListItemButton
              key={user.id}
              onClick={() => onUserSelect(user)}
              disabled={selectedUsers.some((selectedUser) => selectedUser.id === user.id)}
            >
              <ListItemText primary={user.userNickname} secondary={getUserContact(user)} />
            </ListItemButton>
          ))}
        </Box>
      )}

      {searchQuery.length >= 2 && users.length === 0 && !isLoading && (
        <Typography color="textSecondary" sx={{ mt: 1 }}>
          No users found
        </Typography>
      )}
    </Box>
  );
};
